// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__4EAfa","disabled":"TextButton_disabled__KzFM1"};